import styled, { css } from 'styled-components/macro'
import { motion } from 'framer-motion'

import Wallpaper from './assets/wallpaper.png'
import Furniture from './assets/furniture.png'
import { styleReset } from 'styles/misc'
import { mq } from 'styles/mq'

export const View = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${mq.medium} {
    background: url(${Wallpaper}) 50% 0 / cover no-repeat;
  }
`

export const RadioContainer = styled.div`
  --base-unit: 90vmin;
  --knob-size: calc(var(--base-unit) * 0.108);
  --image-native-width: 609;
  --image-native-height: 1035;
  --radio-furniture-overlay: 0.1;

  ${mq.medium} {
    --base-unit: 100vmin;
    --image-native-width: 6929;
    --image-native-height: 4992;
  }

  position: relative;
  width: var(--base-unit);
  aspect-ratio: var(--image-native-width) / var(--image-native-height);

  ${mq.medium} {
    &::before {
      content: '';
      display: block;
      position: absolute;
      top: calc(
        100% -
          (
            var(--base-unit) * var(--image-native-height) /
              var(--image-native-width) * var(--radio-furniture-overlay)
          )
      );
      left: 50%;
      width: 100vw;
      height: calc(
        (
            50vh -
              (
                (var(--base-unit) / 2) *
                  (var(--image-native-height) / var(--image-native-width))
              )
          ) +
          (
            var(--base-unit) * var(--image-native-height) /
              var(--image-native-width) * var(--radio-furniture-overlay)
          )
      );
      transform: translateX(-50%);
      background: url(${Furniture}) center top/cover no-repeat;
    }
  }
`

export const RadioImg = styled.img`
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const UI = styled(motion.span)`
  display: block;
  position: sticky;
  top: 0;
  left: 0;
  width: var(--knob-size);
  height: var(--knob-size);
  border-radius: 50%;

  &::before {
    content: '';
    position: absolute;
    inset: 0.5vw;
    border-radius: 50%;
  }

  &::after {
    content: '';
    position: absolute;
    top: 25%;
    left: 50%;
    width: 0.6rem;
    height: 0.6rem;
    box-sizing: content-box;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background-color: #d2d8d6;
  }
`

export const DebugLine = styled.p`
  margin: 0.5rem 0;
  font-size: 1.6rem;
  text-transform: uppercase;
  font-weight: bold;
`

export const DebugValue = styled.span`
  display: inline-block;
  padding: 0 0.3em;
  border-radius: 3px;
  background-color: #ffdc75;
`

export const TimelineButtons = styled.div`
  position: absolute;
  top: 77%;
  left: 87.9%;
  transform: translateX(-50%);
  font-size: calc(var(--knob-size) * 0.3);
  margin-top: -0.3em;

  button {
    ${styleReset}
    padding: 0 0.3em;
    color: white;
    text-shadow: 0 1px 1px #00000033;
    cursor: pointer;

    &:hover {
      text-shadow: 0 0 4px white, 0 1px 1px #00000033;
    }
  }
`

//background-color: ${props => props.isMuted?"transparent":"#ccc"};
export const MuteButton = styled.div<{ isMuted: boolean }>`
  position: absolute;
  top: 52.8%;
  left: 11%;
  transform: translate(-50%, -50%);
  width: calc(var(--knob-size) / 2);
  height: calc(var(--knob-size) / 2);
  button {
    ${styleReset}
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
`

export const Container = styled.span<{ isSticky?: boolean }>`
  display: block;
  position: absolute;
  top: 63.1%;
  left: 82.5%;
  width: var(--knob-size);
  height: var(--knob-size);
  user-select: none;
  touch-action: none;
  cursor: ew-resize;

  ${props =>
    props.isSticky &&
    css`
      --knob-size: 100%;

      ${UI} {
        display: none;
      }

      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      z-index: 1;
    `}
`
export const Help = styled.div<{ isActive: boolean }>`
  display: ${props => (props.isActive ? 'block' : 'none')};
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`
export const Bubble = styled.div`
  position: absolute;
  display: inline-block;
  background: #fff;
  padding: 8px 16px;
  transform: translate(-50%, -100%);
  font-size: 14px;
  box-shadow: 0 4px 4px 0 rgb(0 0 0 / 20%);

  &.bubble-1 {
    left: 58%;
    top: 44%;

    ${mq.medium} {
      left: 11%;
      top: 47%;
    }
  }

  &.bubble-2 {
    left: 30.8%;
    top: 24%;

    ${mq.medium} {
      left: 46%;
      top: 22%;
    }
  }

  &.bubble-3 {
    left: 67%;
    top: 28%;
    white-space: nowrap;

    ${mq.smallOnly} {
      svg {
        left: 85%;
      }
    }

    ${mq.medium} {
      left: 88%;
      top: 63%;
    }
  }

  &.bubble-4 {
    left: 54%;
    top: 32%;
    max-width: 210px;
    text-align: center;

    ${mq.medium} {
      left: 63%;
      top: 30%;
    }
  }

  &.bubble-video-1 {
    left: 41%;
    top: 45%;
  }

  &.bubble-video-2 {
    left: 86%;
    top: 66%;
  }

  svg {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    background: none;
    fill: #fff;
    width: 10px;
    height: 10px;
  }
`
